import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function minArrayCheckedLength(min = 1): ValidatorFn {
  return (control: AbstractControl<{ selected: boolean }[]>): ValidationErrors | null => {
    const { value } = control;

    const checkedValues = value.filter((value) => !!value.selected).length;

    if (checkedValues >= min) return null;

    return { minChecked: true };
  };
}
